import React from "react";
import { connect } from 'react-redux';
import { CognitoState } from 'react-cognito';
import AmazonOauthCard from "../AmazonOauth/AmazonAuthCard";
import CustomerMainLayout from '../CustomerMainLayout'
import "./integrations.scss"
import WalmartOauthCard from "../WalmartOauth/WalmartAuthCard";
import ShopifyAuthCard from "../ShopifyOauth/ShopifyAuthCard";

const IntegrationsView = ({ state }) => {
    if (state === CognitoState.LOGGED_OUT) {
        window.location.href = "/";
        return null;
    }

    return (
        <>
            <CustomerMainLayout >
                <div style = {{marginTop:"40px"}}>
                    <span style={{padding:"20px"}} className="manrope f-36">Integrations</span> 
                    <div className="integrations-container">
                        <AmazonOauthCard />
                        <WalmartOauthCard />
                        <ShopifyAuthCard />
                    </div>
                </div>
            </CustomerMainLayout>
        </>
    );
}

const mapStateToProps = state => ({
    state: state.cognito.state,
});

const Integrations = connect(mapStateToProps)(IntegrationsView);
export default Integrations;
